var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({staticClass:"white--text",attrs:{"label":"","color":"blue","x-small":""}},'v-chip',{ ..._vm.$props },false),[_vm._v(" "+_vm._s(_vm.value || _vm.user ? (_vm.value || _vm.user).roles[0].name : "...")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }